import React, { useState, useRef, useEffect, useCallback } from 'react';
import './informationBox.css'

import { useSelector, useDispatch } from 'react-redux';
import { meterInfoActions } from '../store/meterInfo';

const InformationBox = ({isWideScreen}) => {
    const dispatch = useDispatch();

    const meterInfo = useSelector(state => state.meterInfo);
    
    const [touchStartY, setTouchStartY] = useState(null);
    const informationBoxRef = useRef(null);

    // 스토어 meter 데이터 초기화
    const getInitialInfoData = () => {
        dispatch(meterInfoActions.reset());
    }

    // 스토어 informationBox 설정
    const setInformationBox = useCallback((informationBox) => {
        dispatch(meterInfoActions.setInformationBox(informationBox));
    }, [dispatch]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (informationBoxRef.current && !informationBoxRef.current.contains(event.target)) {
                setInformationBox(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setInformationBox]);

    const handleTouchStart = (event) => {
        setTouchStartY(event.touches[0].clientY);
    };

    const handleTouchMove = (event) => {
        const touchEndY = event.touches[0].clientY;
        const touchDistance = touchEndY - touchStartY;

        if (touchDistance > 250) {
            setInformationBox(false);
            event.stopPropagation();
        }
    };

    return (
        <div
            ref={informationBoxRef} 
            className={`information-box ${isWideScreen ? "landscape " : ""}${meterInfo.informationBox ? meterInfo.meterId ? 'expanded' : 'expanded little' : ''}`}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}>
            <div className='bar'
             onClick={()=>{ 
                if(!meterInfo.informationBox) {
                    getInitialInfoData();
                }
                setInformationBox(!meterInfo.informationBox);
            }}></div>
            {meterInfo.informationBox ?
                meterInfo.meterId ? 
                <div className='information-group'>
                    <div className={`informaiton ${isWideScreen ? "landscape" : ""}`}>
                        {meterInfo.payPhone ?
                            <>
                            <div className='title'>Pay By Phone</div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>{meterInfo.payPhone}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </>
                        :<></>}
                        {meterInfo.creditCard ?
                            <>
                            <div className='title'>Credit Card Available</div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>{meterInfo.creditCard}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </>
                            :<></>}
                        <div className='title'>
                            <div className='title-sub'>Monday - Friday</div>
                            <div className='title-sub-explain'>Rate per Hour</div>
                        </div>
                        <table>
                            <tbody>
                                <tr>
                                    <td>9am - 6pm</td>
                                    <td>Max {meterInfo.timeLimit9am6pm}</td>
                                    <td>{meterInfo.rate9am6pm}</td>
                                </tr>
                                <tr>
                                    <td>6pm - 10pm</td>
                                    <td>Max {meterInfo.timeLimit6pm10pm}</td>
                                    <td>{meterInfo.rate6pm10pm}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className='title'>
                            <div className='title-sub'>Weekend</div>
                            <div className='title-sub-explain'>Rate per Hour</div>
                        </div>
                        <table>
                            <tbody>
                                <tr>
                                    <td>9am - 6pm</td>
                                    <td>Max {meterInfo.timeLimitWeekend9am6pm}</td>
                                    <td>{meterInfo.rate9am6pm}</td>
                                </tr>
                                <tr>
                                    <td>6pm - 10pm</td>
                                    <td>Max {meterInfo.timeLimitWeekend6pm10pm}</td>
                                    <td>{meterInfo.rate6pm10pm}</td>
                                </tr>
                            </tbody>
                        </table>
                            {meterInfo.flatRate ?
                            <>
                            <div className='title'>Flat Rate</div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>{meterInfo.flatRate}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </>
                            :<></>}
                        <div className='title'>Parking Meter Number</div>
                        <table>
                            <tbody>
                                <tr>
                                    <td>{meterInfo.meterId}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className='title'>Meter Head</div>
                        <table>
                            <tbody>
                                <tr>
                                    <td>{meterInfo.meterHead}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='brokers'>developed by BROKERS</div>
                </div>
                :
                <div className='information-group'>
                    <div className='init-information'>
                        Click a point and get a parking meter info.
                    </div>
                    <div className='brokers'>developed by BROKERS</div>
                </div>
                :
                <></>
            }
        </div>
    );
};

export default InformationBox;